import { Column } from 'components/atoms/grid';
import {
  useColumns,
  toProjectColumns,
  default_column_order,
} from 'components/organisms/tasks/utils';
import { Translate } from 'hooks/use-translation';
import { ProjectField, TaskField } from 'stores/fields';
import { asColumnOrder, ColumnOrder } from '../grid-custom-column';

const relativeSortColumns = (
  source: Column[],
  target: (string | boolean)[][],
): Column[] => {
  const order = Object.fromEntries(
    target.map((v, i) => [v[0], { order: i, hide: v[1] }]),
  );

  return Array.from(source)
    .map((x) => ({ ...x, hide: order[x.name]?.hide ?? false }))
    .sort(
      (a, b) =>
        (order[a.name!]?.order ?? Number.MAX_VALUE) -
        (order[b.name!]?.order ?? Number.MAX_VALUE),
    );
};

const getOrderedColumns = (columns: Column[]): Column[] => {
  const newColumnOrder = default_column_order.map((x) => [x, false]);

  return relativeSortColumns(columns, newColumnOrder);
};

export const getDefaultColumnOrder = (columns: Column[]): ColumnOrder[] => {
  return asColumnOrder(
    getOrderedColumns(columns).map((col) => ({
      ...col,
      colId: col.name,
    })),
  );
};

export const useTaskAndProjectColumns = (
  taskFields: Record<number, TaskField>,
  projectFields: Record<number, ProjectField>,
  translate: Translate,
  includedProjectColumns: string[],
): Column[] => {
  const columns = [
    ...useColumns(taskFields, translate),
    ...toProjectColumns(projectFields, translate, includedProjectColumns),
  ];

  return getOrderedColumns(columns);
};

export const useProjectTaskColumns = (
  fieldsLookupById: Record<number, TaskField>,
  translate: Translate,
): Column[] => {
  const columns = [...useColumns(fieldsLookupById, translate)];

  return getOrderedColumns(columns);
};
